import { BulkUploadType } from '../constants/mediaConfig';

import { matchesMediaType } from './mediaFile';

export const createSessionPreviewUrl = (file: File, mediaType: BulkUploadType): string | null => {
  if (!matchesMediaType(file, mediaType)) return null;
  return URL.createObjectURL(file);
};
